import { Component, Input, output } from '@angular/core';

@Component({
  selector: 'app-mobile-input',
  templateUrl: './mobile-input.component.html',
  styleUrl: './mobile-input.component.scss',
})
export class MobileInputComponent {
  @Input() isNotValid = false;

  inputClick = output<void>();

  onClickInput() {
    this.inputClick.emit();
  }
}
